import { Chip } from "@mui/material";
import pxToRem from "../Themes/Functions/pxToRem";

const ChipButton = (props) => {
  const { children, sx, ...otherProps } = props;
  return (
    <Chip
      clickable
      label={children.toUpperCase()}
      color="primary"
      sx={{
        px: 2,
        fontWeight: "bold",
        fontSize: 12,
        borderRadius: pxToRem(10),

        minWidth: pxToRem(130),
        mx: 1,
        ...sx,
      }}
      {...otherProps}
    />
  );
};

export default ChipButton;
